import { render } from "./xtx-skeleton.vue?vue&type=template&id=86b02dda&scoped=true"
import script from "./xtx-skeleton.vue?vue&type=script&lang=js"
export * from "./xtx-skeleton.vue?vue&type=script&lang=js"

import "./xtx-skeleton.vue?vue&type=style&index=0&id=86b02dda&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b02dda"]])

export default __exports__